<template>
    <ReferralsContainer
        :errorSlug="errorSlug"
        :beforeInit="beforeInit"
        :afterInit="afterInit"
    />
</template>

<script>
import { get } from 'lodash-es';
import { mapGetters, mapMutations } from 'vuex';

import { PROFILE_MODULE_NAME } from '~modules/profile/js/profile-store';
import referralsModule, { REFERRALS_MODULE_NAME, SET_FRIENDBUY_CLICK } from '~routes/referrals/js/referrals-store';

import { rentalRouteNames } from '~modules/core/js/router-constants';
import { CONTENT_SLUGS } from '~modules/contentful/js/contentful-constants';
import { FRIENDBUY_REFERRAL_TYPES } from '~routes/referrals/js/referrals-constants';

import ReferralsContainer from '~routes/referrals/components/ReferralsContainer.vue';

export default {
    name: 'CheckReferralInvite',
    components: {
        ReferralsContainer,
    },
    vuex: {
        moduleName: REFERRALS_MODULE_NAME,
        module: referralsModule,
    },
    data() {
        return {
            errorSlug: null,
        };
    },
    computed: {
        ...mapGetters([
            'loggedIn',
        ]),
        ...mapGetters(PROFILE_MODULE_NAME, [
            'isAnonymousOrNonSubscriber',
        ]),
        referralInviteLink() {
            const route = {
                name: rentalRouteNames.referrals.invite,
            };

            const type = get(this.$route, 'query.type');

            if (type === FRIENDBUY_REFERRAL_TYPES.INFLUENCER) {
                route.query = {
                    type: FRIENDBUY_REFERRAL_TYPES.INFLUENCER,
                };
            }

            return route;
        },
    },
    methods: {
        ...mapMutations(REFERRALS_MODULE_NAME, {
            setFriendbuyClick: SET_FRIENDBUY_CLICK,
        }),
        beforeInit() {
            const { referralCode } = this.$route.query;

            if ((!referralCode) || !this.isAnonymousOrNonSubscriber) {
                this.errorSlug = CONTENT_SLUGS.REFERRALS_EMAIL_CAPTURE_INELIGIBLE_SLUG;
                return false;
            }

            return true;
        },
        afterInit(friendbuyAPI) {
            friendbuyAPI.push(['getVisitorStatus', (response) => {
                const { payload } = response;

                if (payload.isSelfReferral || payload.referralCodeBlocked) {
                    this.errorSlug = CONTENT_SLUGS.SELF_REFERRAL_EMAIL_CAPTURE_SLUG;
                } else {
                    this.setFriendbuyClick(true);
                    this.$router.push(this.referralInviteLink);
                }
            }]);
        },
    },
};
</script>

<style lang="scss">

</style>
